import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { ActuatorHealth, ActuatorInfo } from 'src/rdsap-api';
import { AGGREGATED_DATA_SERVICE_TOKEN, IAggregatedDataService } from 'src/rdsap/models/data/aggregated-data.interface';
import { environment } from 'src/environments/environment';
import packageInfo from '../../../../../package.json';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy  {
  rdSAPInfo$: Observable<ActuatorInfo[]>;
  info: ActuatorInfo;
  rdSAPHealth$: Observable<ActuatorHealth[]>;
  health: ActuatorHealth;
  env = environment;
  version = packageInfo.version;

  private subscriptions = new Subscription();

  constructor(@Inject(AGGREGATED_DATA_SERVICE_TOKEN) private aggregatedDataService: IAggregatedDataService) { }

  ngOnInit() {
    this.setupInfoStream();
    this.setupHealthStream();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  
  ngAfterViewInit() {
    const trigger = document.getElementById('api-data-trigger');
    const details = document.getElementById('api-details-data');
    const status = document.getElementById('api-status');
    let clickCount = 0;

    trigger.addEventListener('click', () => {
      clickCount++;

      if (clickCount === 3) {
        if (details.classList.contains('hidden')) {
          details.classList.remove('hidden');
          status.classList.remove('hidden');
        } else {
          details.classList.add('hidden');
          status.classList.add('hidden');
        }
        clickCount = 0; 
      }
    });
  }


  private setupInfoStream() {
    this.aggregatedDataService.loadRdSAPInfo();
    this.rdSAPInfo$ = this.aggregatedDataService.rdSAPInfo$;
    const infoSubscription = this.rdSAPInfo$.subscribe(data => {
      if (data.length) {
        this.info = data[0];
      }
    });
    this.subscriptions.add(infoSubscription);
  }

  private setupHealthStream() {
    this.aggregatedDataService.loadRdSAPHealth();
    this.rdSAPHealth$ = this.aggregatedDataService.rdSAPHealth$;
    const healthSubscription = this.rdSAPHealth$.subscribe(data => {
      if (data.length) {
        this.health = data[0];
      }
    });
    this.subscriptions.add(healthSubscription);
  }

  isStatusUp(): boolean {
    return this.health?.status === 'UP';
  }
}
